module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('a', {
    attrs: {
      "id": "part01chapter06"
    }
  }), _vm._v("CHAPTER 6")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/line1.gif"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Finding God would be difficult, but finding lunch was easy. I left Vital Records, past the customers, smokers, and staff, who traded resigned looks as they realized the alarm had ended with no fire trucks in sight. I put the same quarter in the same meter and got it back. I was starting to like it here. Down the street a meter maid ticketed a car. She glared at me. I flipped the quarter and caught it, George Raft-style, then leered at her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("My stomach growled in anticipation. I crossed Maine Avenue and bellied up to the counter of Custis and Brown’s, where I slammed down two bowls of Maryland she-crab chowder, then placed a call to Lieutenant Emil Haggler, a D.C. homicide cop I knew. A male voice answered second district. I asked for Haggler, was put on hold, then a voice came over the phone and said, “Haggler.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“It’s Willis.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Well, well. Where you been, son?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Here and there. I wonder could you do me a favor?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“No more parkin’ tickets, Willis, I done told you before.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“This is different. I’m trying to find someone for a friend of mine and I wonder could you help me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Oh, yeah, the part-time "), _c('em', [_vm._v("de")]), _vm._v("tective,” he said. “Somebody late on their alimony?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“No, missing person, and it’s the first case I’ve had this year that doesn’t involve infrared video and telephoto lenses.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Glad to hear it. I can think of another cop who’d approve.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _vm._v("He was talking about Captain Shadrack Davies, who had been Emil’s boss and one of my foster fathers. This was my cue to say something about Shad. Instead, I kept on target. “Right. So how about a search on Jackson, Bobbie?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Man or woman?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Woman, African American, about twenty to twenty-five years old.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Where you looked so far?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Just a request at Vital Records.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Okay. I could check our files, see she has a criminal record.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Good. Could you also check DMV?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I could hear him scribbling away. “Anything else?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Phone and utilities. Oh, and bank accounts.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Christ, you want me to wipe your ass for you, too?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“No, I’m doing pretty good with that now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Could have fooled me.” Then he hung up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I was lucky I’d caught him on a good day.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-811733a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part01chapter06.vue
// module id = 93
// module chunks = 0